var _polygon, _rect, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _rect2, _rect3, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPB4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.4.1",
    points: "270 370 365 370 365 381 392 381 392 569 331 569 331 532 270 532 270 370"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.4.2",
    x: 79,
    y: 370,
    width: 186.85,
    height: 162
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.4.3",
    points: "91 198 266 198 266 329 165 329 165 366 91 366 91 198"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.4.4",
    points: "270 185 392 185 392 329 297 329 297 318 270 318 270 185"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.4.5",
    points: "396.17 185 462.03 185 462.03 149 518 149 518 318.2 492 318.2 492 329 396.17 329 396.17 185"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.4.6",
    points: "523.03 149 578 149 578 185 587 185 644 185 644 329 549 329 549 318 523.03 318 523.03 149"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.4.7",
    points: "649 167 770 167 770 318 744 318 744 329 649 329 649 167"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.4.8",
    points: "774.88 167 911 167 911 300 898 300 898 366 774.88 366 774.88 167"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.4.9",
    x: 747,
    y: 370,
    width: 151,
    height: 132
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.4.10",
    x: 649,
    y: 370,
    width: 93.14,
    height: 132
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.4.11",
    points: "548.94 370 644 370 644 514 584 514 584 550 523.13 550 523.13 381.17 549 381.17 548.94 370"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmlld0JveD0iMCAwIDk5MCA3MjAiPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjQuMSIgcG9pbnRzPSIyNzAgMzcwIDM2NSAzNzAgMzY1IDM4MSAzOTIgMzgxIDM5MiA1NjkgMzMxIDU2OSAzMzEgNTMyIDI3MCA1MzIgMjcwIDM3MCIvPgoKCiAgICA8cmVjdCBkYXRhLWlkPSJCLjQuMiIgeD0iNzkiIHk9IjM3MCIgd2lkdGg9IjE4Ni44NSIgaGVpZ2h0PSIxNjIiLz4KCgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi40LjMiIHBvaW50cz0iOTEgMTk4IDI2NiAxOTggMjY2IDMyOSAxNjUgMzI5IDE2NSAzNjYgOTEgMzY2IDkxIDE5OCIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjQuNCIgcG9pbnRzPSIyNzAgMTg1IDM5MiAxODUgMzkyIDMyOSAyOTcgMzI5IDI5NyAzMTggMjcwIDMxOCAyNzAgMTg1Ii8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuNC41IiBwb2ludHM9IjM5Ni4xNyAxODUgNDYyLjAzIDE4NSA0NjIuMDMgMTQ5IDUxOCAxNDkgNTE4IDMxOC4yIDQ5MiAzMTguMiA0OTIgMzI5IDM5Ni4xNyAzMjkgMzk2LjE3IDE4NSIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjQuNiIgcG9pbnRzPSI1MjMuMDMgMTQ5IDU3OCAxNDkgNTc4IDE4NSA1ODcgMTg1IDY0NCAxODUgNjQ0IDMyOSA1NDkgMzI5IDU0OSAzMTggNTIzLjAzIDMxOCA1MjMuMDMgMTQ5Ii8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuNC43IiBwb2ludHM9IjY0OSAxNjcgNzcwIDE2NyA3NzAgMzE4IDc0NCAzMTggNzQ0IDMyOSA2NDkgMzI5IDY0OSAxNjciLz4KCgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi40LjgiIHBvaW50cz0iNzc0Ljg4IDE2NyA5MTEgMTY3IDkxMSAzMDAgODk4IDMwMCA4OTggMzY2IDc3NC44OCAzNjYgNzc0Ljg4IDE2NyIvPgoKCiAgICA8cmVjdCBkYXRhLWlkPSJCLjQuOSIgeD0iNzQ3IiB5PSIzNzAiIHdpZHRoPSIxNTEiIGhlaWdodD0iMTMyIi8+CgoKICAgIDxyZWN0IGRhdGEtaWQ9IkIuNC4xMCIgeD0iNjQ5IiB5PSIzNzAiIHdpZHRoPSI5My4xNCIgaGVpZ2h0PSIxMzIiLz4KCgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi40LjExIiBwb2ludHM9IjU0OC45NCAzNzAgNjQ0IDM3MCA2NDQgNTE0IDU4NCA1MTQgNTg0IDU1MCA1MjMuMTMgNTUwIDUyMy4xMyAzODEuMTcgNTQ5IDM4MS4xNyA1NDguOTQgMzcwIi8+Cgo8L3N2Zz4=";
export { SvgPB4 as ReactComponent };